"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * Call an editing callback with adding undo snapshots around, and trigger a ContentChanged event if change source is specified.
 * Undo snapshot will not be added if this call is nested inside another editWithUndo() call.
 * @param core The EditorCore object
 * @param callback The editing callback, accepting current selection start and end position, returns an optional object used as the data field of ContentChangedEvent.
 * @param changeSource The ChangeSource string of ContentChangedEvent. @default ChangeSource.Format. Set to null to avoid triggering ContentChangedEvent
 */
exports.editWithUndo = function (core, callback, changeSource) {
    var isNested = core.currentUndoSnapshot !== null;
    var data;
    if (!isNested) {
        core.currentUndoSnapshot = core.corePlugins.undo.addUndoSnapshot();
    }
    try {
        if (callback) {
            var range = core.api.getSelectionRange(core, true /*tryGetFromCache*/);
            data = callback(range && roosterjs_editor_dom_1.Position.getStart(range).normalize(), range && roosterjs_editor_dom_1.Position.getEnd(range).normalize(), core.currentUndoSnapshot);
            if (!isNested) {
                core.corePlugins.undo.addUndoSnapshot();
            }
        }
    }
    finally {
        if (!isNested) {
            core.currentUndoSnapshot = null;
        }
    }
    if (callback && changeSource) {
        var event_1 = {
            eventType: 6 /* ContentChanged */,
            source: changeSource,
            data: data,
        };
        core.api.triggerEvent(core, event_1, true /*broadcast*/);
    }
};
//# sourceMappingURL=editWithUndo.js.map